import script from "./AuthManager.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuthManager.vue?vue&type=script&setup=true&lang=ts"

import "./AuthManager.vue?vue&type=style&index=0&id=af6b52a0&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af6b52a0"]])

export default __exports__